<template>
  <ubi-page-container class="Broadcast" wide-main-content>
    <template v-slot:page-actions>
      <span class="inline" v-if="selected.length != 0">{{ selected.length }} {{ $t('portals.broadcast.selectedAds', { count: selected.length }) }}</span>
      <span class="inline">&nbsp;</span>
      <el-tooltip :content="$t('portals.broadcast.noSelectionWarning')" :disabled="selected.length > 0" placement="bottom" :visible-arrow="false">
        <span class="inline">
          <el-button @click="confirmDesactivationList = true" inline type="warning" :disabled="selected.length === 0">
            <span @click="eventAnalytics('desactiver_diffusion')">{{ $t('portals.broadcast.disableDiffusion') }}</span>
          </el-button>
        </span>
      </el-tooltip>
      <el-tooltip :content="$t('portals.broadcast.noSelectionWarning')" :disabled="selected.length > 0" placement="bottom" :visible-arrow="false" v-if="(isPromoteur || isBailleurSocial) && filter.annonceParente == null">
        <span class="inline">
          <el-button @click="programValidLotModal = true" inline type="primary" :disabled="selected.length === 0">
            <span @click="eventAnalytics('diffuser_annonces')">{{ $t('portals.broadcast.diffuseAds') }}</span>
          </el-button>
        </span>
      </el-tooltip>
      <el-tooltip :content="$t('portals.broadcast.noSelectionWarning')" :disabled="selected.length > 0 && isModeSelectionAutomatiqueManuelleParAnnonceur" placement="bottom" :visible-arrow="false" v-else>
        <span class="inline">
          <el-button @click="confirmDiffusionList = true" :disabled="selected.length === 0 || !isModeSelectionAutomatiqueManuelleParAnnonceur" inline type="primary">
            <span @click="eventAnalytics('diffuser_annonces')">{{ $t('portals.broadcast.diffuseAds') }}</span>
          </el-button>
        </span>
      </el-tooltip>
    </template>

    <div v-loading="loading || loadingActivation" :element-loading-text="$t('portals.list.chargementDonnees')">
      <ubi-panel>
        <el-dialog class="ValiderSelection" :title="$t('portals.list.portalSelectionActivateDiffusionTitle')" :visible.sync="programValidLotModal">
          <span>{{ $t('portals.list.portalSelectionActivateDiffusionText') }}</span><br/><br/>
          <el-checkbox v-if="isPromoteur && filter.annonceParente == null" v-model="checkLots" true-label="oui" false-label="non">
            {{ $t('portals.list.validateLotsDiffusion') }}
          </el-checkbox>
          <el-checkbox v-if="isBailleurSocial && filter.annonceParente == null" v-model="checkLots" true-label="oui" false-label="non">
            {{ $t('portals.list.validateLotsDiffusionBailleur') }}
          </el-checkbox>

          <span slot="footer" class="dialog-footer">
          <el-button @click="programValidLotModal = false">{{ $t('portals.list.cancel') }}</el-button>
          <el-button type="primary" @click="validerSelection">{{ $t('portals.list.confirm') }}</el-button>
        </span>
        </el-dialog>
        <el-dialog :title="$t('portals.broadcast.confirmSelectionDeactivationTitle')" :visible.sync="confirmDesactivationList" width="30%">
          <span class="text-left">{{ $t('portals.broadcast.confirmSelectionDeactivation') }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="confirmDesactivationList = false">{{ $t('posts.dialog.cancel') }}</el-button>
            <el-button type="primary" @click="desactiverSelection"> {{ $t("portals.broadcast.deactivated") }}</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$t('portals.broadcast.confirmSelectionDiffusionTitle')" :visible.sync="confirmDiffusionList" width="30%">
          <span class="text-left">{{ $t('portals.broadcast.confirmSelectionDiffusion') }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="confirmDiffusionList = false">{{ $t('posts.dialog.cancel') }}</el-button>
            <el-button type="primary" @click="validerSelection"> {{ $t("portals.broadcast.broadcast") }}</el-button>
          </span>
        </el-dialog>
        <el-row :gutter="20">
          <el-col :lg="20" :md="12">
            <h1 v-if="portal && portal.infos">{{ portal.infos.diffuseurNom }}</h1>

            <el-row v-if="!isPromoteur && ( (isMainAccount || isSubAdmin) || !getQuotaPersonnel || getQuotaCurrentUser === 'Aucun Quota' )">
              <el-col :lg="8" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.broadcast.quota') }}</strong>

                <p v-if="portal && portal.infos && portal.infos.quotaIllimite === true">{{
                    $t('portals.broadcast.quotaUnlimited')
                  }}
                </p>
                <p v-else-if="isMainAccount && portal && portal.infos && portal.infos.nbAnnoncesQuota !== null">{{ portal.infos.nbAnnoncesQuota }}</p>
                <!-- Pour subUser sans quota personnel: afficher données globales portail -->
                <p v-else-if="getQuotaCurrentUser === 'Aucun Quota' && portal && portal.infos">
                  {{ portal.infos.nbAnnoncesEnvoyees }}/{{ portal.infos.nbAnnoncesQuota }}
                </p>
                <p v-else-if="!quotaPerUser && portal && portal.infos && portal.infos.nbAnnoncesQuota">{{ portal.infos.nbAnnoncesQuota }}</p>
                <p v-else-if="quotaPerUser && getUserQuotaPerPortal">{{ getQuotaForUserPorPortal }}</p>
                <p v-else>{{ getQuotaCurrentUser }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal && portal.infos && portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else-if="portal && portal.infos">{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3" v-if="portal != null && !isPromoteur">
                <!-- Libellé différent selon isMainAccount -->
                <strong v-if="isMainAccount">{{ $t('portals.broadcast.broadcastedAds') }}</strong>
                <strong v-else>{{ $t('portals.broadcast.selectedAds') }}</strong>
                <br>
                <div v-if="isMainAccount">{{portal.infos.nbAnnoncesEnvoyees}}</div>
                <!-- Affichage du nombre d'annonces selon le type de compte -->
                <!-- Pour subUser sans quota personnel: afficher seulement le nombre, sans warnings -->
                <div v-else-if="!isMainAccount && getQuotaCurrentUser === 'Aucun Quota'">
                  <span>{{ getSelectedAdsCurrentUser }}</span>
                </div>
                <!-- Pour les autres cas: affichage avec warnings si applicable -->
                <div v-else-if="!isMainAccount && portal && portal.infos && ((portal.infos.nbAnnoncesQuota - getSelectedAdsCurrentUser) < 0) && portal.infos.quotaIllimite === false && quotaPerUser" style="color: #d35b68">
                  <span>{{ getSelectedAdsCurrentUser }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else-if="!isMainAccount && portal && portal.infos && ((portal.infos.nbAnnoncesQuota - getSelectedAdsCurrentUser) < 600) && ((portal.infos.nbAnnoncesQuota - getSelectedAdsCurrentUser) > 0) && portal.infos.quotaIllimite === false && quotaPerUser" style="color: darkorange">
                  <span>{{ getSelectedAdsCurrentUser }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start">
                    <div slot="content">
                      {{
                        $t('portals.broadcast.remainingMessageQuota', {
                          number:
                            portal.infos.nbAnnoncesQuota - getSelectedAdsCurrentUser
                        })
                      }}
                    </div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else>
                  <span>{{ getSelectedAdsCurrentUser }}</span>
                  <!-- Afficher le quota seulement si l'utilisateur a un quota personnel réel -->
                  <span
                    v-if="quotaPerUser && portal && portal.infos && portal.infos.nbAnnoncesQuota && portal.infos.nbAnnoncesQuota > 0">/{{ portal.infos.nbAnnoncesQuota }}</span>
                  <span v-else-if="quotaPerUser && portal && portal.infos">/{{ portal.infos.nbAnnoncesMax }}</span>
                </div>
              </el-col>
              <el-col :lg="8" class="mb-3" v-if="portal != null && !isPromoteur && isMainAccount">
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }}</strong>
<!--                (bug #115179 ) => Nombre d'annonces selectionnées par portail (annonceSelectionneeForPortail) Store broadcast localforage -->
                <div>{{ quotaData.annonceSelectionneeForPortail }}</div>
              </el-col>
            </el-row>

            <!-- Affichage quota personnel (seulement si un quota réel est configuré) -->
            <el-row v-if="getQuotaPersonnel && !isPromoteur && getQuotaCurrentUser !== 'Aucun Quota'">
              <el-col :lg="8" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.list.quotaPerso') }}</strong>
                <p v-if="portal && portal.infos && portal.infos.quotaIllimite === true">
                  {{ $t('portals.broadcast.quotaUnlimited') }}
                </p>
                <p v-else>
                  {{ getQuotaForUserPorPortal }}
                </p>
              </el-col>
              <el-col :lg="8" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal && portal.infos && portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else-if="portal && portal.infos">{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>

              <el-col :lg="8" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }}</strong>
                <br>
                <div v-if="getQuotaForUserPorPortal && getSelectedAdsCurrentUser < getQuotaForUserPorPortal">
                  {{getSelectedAdsCurrentUser}}
                  <el-tooltip placement="top-start">
                    <div slot="content"> {{
                        $t('portals.broadcast.remainingMessageQuota', {
                          number:
                            getQuotaForUserPorPortal - getSelectedAdsCurrentUser
                        })
                      }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else-if="getQuotaForUserPorPortal && getQuotaForUserPorPortal === getSelectedAdsCurrentUser">
                  {{getSelectedAdsCurrentUser}}
                  <el-tooltip placement="top-start" v-if="portal && portal.infos && !portal.infos.quotaIllimite">
                    <div slot="content">{{ $t('portals.broadcast.reachedAdsLimitQuotas') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>

                <div v-else-if="getQuotaForUserPorPortal && getSelectedAdsCurrentUser > getQuotaForUserPorPortal" style="color: #d35b68">
                  {{getSelectedAdsCurrentUser}}
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
              </el-col>

            </el-row>
            <!-- Pour les promoteurs-->
            <el-row v-if="isPromoteur && (isMainAccount || isSubAdmin || (user && user.mainAccount && !user.multiAccounts) || !quotaPersonnel)"><!-- Section promoteur principale incluant les comptes principaux simples -->
              <el-col :lg="8" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.broadcast.quota') }}</strong>
                <p v-if="portal && portal.infos && portal.infos.quotaIllimite === true">{{
                    $t('portals.broadcast.quotaUnlimited')
                  }}</p>
                <p v-else-if="portal && portal.infos">{{ portal.infos.nbAnnoncesQuota }}</p>
              </el-col>
              <el-col :lg="16" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal && portal.infos && portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else-if="portal && portal.infos">{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }} :</strong>
                <br>
                <div
                  v-if="portal && portal.infos && (( (getSelectedAdsCurrentUser) > portal.infos.nbAnnoncesQuota)) && portal.infos.quotaIllimite === false"
                  style="color: #d35b68">
                  <span>{{ getSelectedAdsCurrentUser }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }} :</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else>
                  <span>{{ getSelectedAdsCurrentUser }}</span>
                  <span
                    v-if="portal && portal.infos && portal.infos.nbAnnoncesQuota && portal.infos.nbAnnoncesQuota > 0">/{{ portal.infos.nbAnnoncesQuota }}</span>
                </div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaProgram') }} :</strong>
                <br/>
                <div>{{ promoteurData.nbAnnoncesSelectionneesProgrammes }} / {{ promoteurData.nbProgrammesTotal }}</div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaLot') }} :</strong>
                <br/>
                <div>{{ promoteurData.nbAnnoncesSelectionneesLots }} / {{ promoteurData.nbLotsTotal }}</div>
              </el-col>
              <el-col :lg="24" class="mb-3" v-if="quotaPersonnel && !(user && user.mainAccount && !user.multiAccounts)">
                <hr>
              </el-col>
            </el-row>
            <!--                    Quota personnel promoteur -->
            <el-row v-if="quotaPersonnel && isPromoteur && !(user && user.mainAccount && !user.multiAccounts)"><!-- Section quota personnel pour subUser seulement, pas pour les comptes principaux simples -->
              <el-col :lg="8" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.list.quotaPerso') }}</strong>
                <p v-if="portal && portal.infos && portal.infos.quotaIllimite === true">{{ $t('portals.broadcast.quotaUnlimited') }}</p>
                <p v-else>{{ getQuotaForUserPorPortal }}</p>
              </el-col>
              <el-col :lg="16" class="mb-3" v-if="portal && portal.infos">
                <strong>{{ $t('portals.broadcast.lastDiffusion') }}</strong>
                <p v-if="portal && portal.infos && portal.infos.dateDernierEnvoi == null">{{
                    $t('portals.broadcast.lastDiffusionUnknown')
                  }}</p>
                <p v-else-if="portal && portal.infos">{{ portal.infos.dateDernierEnvoi }}</p>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.selectedAdsPortal') }} :</strong>
                <br>
                <div
                  v-if="getQuotaForUserPorPortal && ((getNbLotsTotalUser + getNbProgrammesTotalUser) > getQuotaForUserPorPortal)"
                  style="color: #d35b68">
                  <span>{{ getNbLotsActifsUser + getNbProgrammesActifsUser }} / {{ getNbLotsTotalUser + getNbProgrammesTotalUser }}</span>
                  <span>&nbsp;</span>
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.overMessageQuota') }} :</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else>
                  <span>{{ getNbLotsActifsUser + getNbProgrammesActifsUser }} / {{ getNbLotsTotalUser + getNbProgrammesTotalUser }}</span>
                </div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaProgram') }} :</strong>
                <br/>
                <div>{{ getNbProgrammesActifsUser }} / {{ getNbProgrammesTotalUser }}</div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t('portals.broadcast.quotaLot') }} :</strong>
                <br/>
                <div>{{ getNbLotsActifsUser }} / {{ getNbLotsTotalUser }}</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="4" :md="12">
            <div class="text-muted" style="text-align: center;">
              <el-image
                :src="portal.infos._embedded.diffuseur.logo"
                :srcset="portal.infos._embedded.diffuseur.logo"
                v-if="portal && portal.infos && portal.infos._embedded && portal.infos._embedded.diffuseur"
              />
            </div>
          </el-col>
        </el-row>
      </ubi-panel>

      <ApiSearchForm
        :template-code="templateCode"
        :business-domain="businessDomain"
        :route="route"
        @search="handleSearchFromApi"
        @reset="handleResetFromApi"
      />

      <ubi-panel :full-width="browserContext.up('lg')" v-if="portal && portal.infos">
        <ubi-list-header
          slot="header"
          :limits="limits"
          :total="results && results.total ? results.total : 0"
          :page.sync="page"
          :limit.sync="limit"
          :sort.sync="sort"
          :sortProperties="sortProperties"
        >

        </ubi-list-header>
        <template slot="selection">
          <ubi-list-selection
            v-model="selected"
            arrow-down
            :total="results && results.count ? results.count : 0"
            :selection="selections"
            @select="doSelect"
          />
        </template>
        <template slot="actions">
          <el-button size="mini" v-if="filter.annonceParente != null"
                     @click="retourProgramme(filter.annonceParente)">
            {{ $t('portals.broadcast.backProgram') }}
          </el-button>
        </template>

        <ubi-list-footer
          slot="footer"
          :limits="limits"
          :total="results && results.total ? results.total : 0"
          :page.sync="page"
          :limit.sync="limit"
          :sort.sync="sort"
          :sortProperties="sortProperties"
        ></ubi-list-footer>
        <el-table
          ref="table"
          :data="results && results.list ? results.list : []"
          @select="selectedChanged"
          @select-all="selectAllChanged"
          v-if="browserContext.up('lg') && portal != null"
          @sort-change="trieTableau"
        >
          <el-table-column fixed type="selection" width="70" :selectable="canSelectRow" v-if="possedeSelectionPertinente"></el-table-column>
          <el-table-column fixed type="selection" width="70" v-else></el-table-column>
          <el-table-column
            fixed
            min-width="120"
            align="center"
            header-align="center"
            :label="$t('portals.broadcast.columnSelected')"
            prop="col_diff"
            sortable="custom"
          >
            <template v-slot="{ row }">
              <div>
                <div v-if="possedeSelectionPertinente && row.selectionPertinente === '0'">
                  <el-tooltip placement="top-start">
                    <div slot="content" v-html="formatMessageTooltip(row.messageSelectionPertinente)"></div>
                    <em class="el-icon-question text-warning mr-2" style="font-size:1.9em;"/>
                  </el-tooltip>
                </div>
                <div v-else-if="row.estActiveDiffuseur == true"><em class="el-icon-success text-success mr-2" style="font-size:2em;" /></div>
                <div v-else>-</div>
              </div>
              <div style="font-size: 12px; margin-top: 8px;">{{ row.date_maj_selection }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnPicture')" min-width="200">
            <template v-slot="{ row }">
              <img
                alt=""
                v-if="row.photoPrincipale != null"
                :src="row.photoPrincipale.url_miniature"
                height="80"
              />
              <div v-else style="text-align: center;">
                <ubi-icon class="no-photo" name="camera" size="100"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="dateCreation" sortable :label="$t('portals.report.columnDateCreation')" min-width="140">
            <template v-slot="{row}">
              {{ row.dateCreation && row.dateCreation.substring ? row.dateCreation.substring(0, 10) : '-' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnReference')" prop="col_ref" min-width="180"
                           sortable="custom">
            <template v-slot="{ row }">
              <strong style="color: #d35b68">{{ row.reference }}</strong>
              <div class="small">{{ row.titre }}</div>
              <el-tags-posts :size="size" :typeObjet="row.typeObjet" :typeOffre="row.typeOffre" :annonceParente="row.annonceParente"
                             v-if="isBailleurSocial">
              </el-tags-posts>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnCity')" min-width="200">
            <template
              v-slot="{ row }"
            >
              <div v-if="row.donnees && row.donnees.ville && row.donnees.code_postal">
                {{ row.donnees.ville.valeur }}({{ row.donnees.code_postal.valeur }})
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.broadcast.columnPrice')" prop="col_price" min-width="200" sortable="custom" v-if="!isPromoteur || (isPromoteur && filter.annonceParente)">
            <template v-slot="{ row }">
              <div v-if="row.prix != 'Loyer : nous consulter'">{{ row.prixDisplay }}</div>
              <div v-else>{{ $t('portals.broadcast.priceContactUs') }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.list.nbLotsBroadcasted')" min-width="120" v-if="((isPromoteur || isBailleurSocial) && filter.annonceParente == null)">
            <template v-slot="{ row: result }">
              <a v-if="result.typeObjet >= 3000 && result.typeObjet < 4000">
                {{ result.nbLotsCoches }}/{{ result.nbLots }}
              </a>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Actions" align="right" min-width="100">
            <template v-slot="{ row }">
              <el-button v-if="(isPromoteur || isBailleurSocial) && row.typeObjet >= 3000 && row.typeObjet <= 4000 && filter.annonceParente == null" @click="setProgramme(row.id)" class="Route" size="mini">{{ $t('posts.card.seeLots') }}</el-button>
              <router-link v-else :to="{ name: 'post-view', params: { post: row.id } }" target="_blank" rel="noopener" class="Route">
                <el-button size="mini" icon="eye"></el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>

        <!-- Affichage du tableau en mode responsive -->
        <ubi-card-container :data="results && results.list ? results.list : []" v-loading.fullscreen.lock="loading"
                            :element-loading-text="$t('portals.list.chargementDonnees')" v-else>
          <template v-slot="{ row: result }">
            <ubi-card v-model="selected" :label="String(result.id)">
              <template slot="header">
                <div style="text-align: center;">
                  <img
                    alt=""
                    width="50%"
                    :src="result.logo"
                    :srcset="result.logo"
                  />
                </div>
              </template>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  <h3>{{ result.titre }}</h3>
                </el-col>
                <el-col :span="null">{{ result.reference }}</el-col>
              </el-row>
              <el-row><br/></el-row>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  {{ result.donnees && result.donnees.ville && result.donnees.ville.valeur ? result.donnees.ville.valeur : '-' }}
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  {{ result.prixDisplay }}
                </el-col>
                <el-col :span="null">
                  {{ result.dateCreation }}
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between">
                <img style="margin: auto;" v-if="result.photoPrincipale != null"
                     alt=""
                     :src="result.photoPrincipale.url" height="150"/>
                <div style="margin: auto;" v-else>
                  <ubi-icon class="no-photo" name="camera" size='150'/>
                </div>
              </el-row>
              <el-row type="flex" justify="space-between">
                <el-col :span="null">
                  <el-button
                    v-if="(isPromoteur || isBailleurSocial) && result.typeObjet >= 3000 && result.typeObjet <= 4000 && filter.annonceParente == null"
                    @click="setProgramme(result.id)" class="Route" size="mini">Voir les lots
                  </el-button>
                  <router-link v-else :to="{ name: 'post-view', params: { post: result.id } }"
                               target="_blank" rel="noopener" class="Route">
                    <el-button size="mini" icon="eye"></el-button>
                  </router-link>
                </el-col>
                <el-col :span="null">
                  <div v-if="possedeSelectionPertinente">
                    <em class="el-icon-success text-success mr-2" style="font-size:2em;"
                        v-if="result.estActiveDiffuseur == true"/>
                    <div v-else>
                      <el-tooltip placement="top-start" v-if="result.selectionPertinente === '0'">
                        <div slot="content"
                             v-html="formatMessageTooltip(row.messageSelectionPertinente)">
                        </div>
                        <em class="el-icon-question text-warning mr-2" style="font-size:1.9em;"/>
                      </el-tooltip>
                    </div>
                  </div>
                  <div v-else>
                    <em class="el-icon-success text-success mr-2" style="font-size:2em;"
                        v-if="result.estActiveDiffuseur == true"/>
                    <span v-else>-</span>
                  </div>
                </el-col>
              </el-row>
            </ubi-card>
          </template>
        </ubi-card-container>
      </ubi-panel>
    </div>
  </ubi-page-container>
</template>
<style>
.el-loading-spinner {
  top: 10% !important;
}
</style>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import _uniq from 'lodash/uniq'
import TagsPosts from '../posts/components/TagsPosts'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListSelection from '@/components/lists/ListSelection.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'
import UbiIcon from '@/components/Icon.vue'
import UbiCardContainer from '@/components/CardContainer.vue'
import UbiCard from '@/components/Card.vue'

export default {
  name: 'Broadcast',
  components: {
    UbiCard,
    UbiCardContainer,
    UbiIcon,
    UbiListFooter,
    UbiListSelection,
    UbiListHeader,
    UbiPanel,
    UbiPageContainer,
    ElTagsPosts: TagsPosts,
    ApiSearchForm
  },
  inject: ['browserContext'],
  data () {
    return {
      portalId: this.$route.params.portal,
      limits: [10, 10 * 2, 10 * 5],
      selected: [],
      selection: null,
      selections: [],
      allPostsSelected: [],
      size: 'medium',
      sortProperties: {},
      checkLots: true,
      programValidLotModal: false,
      confirmDesactivationList: false,
      confirmDiffusionList: false,
      // Propriété pour la logique d'affichage des sections
      quotaPersonnel: false
    }
  },
  computed: {
    ...mapGetters(['isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes']),
    ...mapGetters('broadcast', [
      'isLoading',
      'isLoadingActivation',
      'getCurrentPortal',
      'getQuotaCurrentUser',
      'getSelectedAdsCurrentUser',
      'getPromoteurData',
      'getQuotaData',
      // Nouveaux getters détaillés
      'getQuotaPersonnel',
      'getQuotaForUserPorPortal',
      'getTotalAnnoncesForUser',
      'getUserQuotaPerPortal',
      'getPortalCodeName',
      'getNbProgrammesTotalUser',
      'getNbLotsTotalUser',
      'getNbProgrammesActifsUser',
      'getNbLotsActifsUser'
    ]),
    ...mapState('broadcast', ['filter', 'results', 'portal']),

    // Propriété sécurisée pour results avec vérification défensive
    safeResults () {
      return this.results || { total: 0, count: 0, list: [] }
    },

    loading () {
      return this.isLoading
    },

    loadingActivation () {
      return this.isLoadingActivation
    },

    promoteurData () {
      return this.getPromoteurData || {
        nbAnnoncesSelectionneesProgrammes: 0,
        nbProgrammesTotal: 0,
        nbAnnoncesSelectionneesLots: 0,
        nbLotsTotal: 0
      }
    },

    quotaData () {
      return this.getQuotaData
    },

    user () {
      return this.$store.getters.getUser
    },

    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },

    univers () {
      return this.sitimmoUser.univers
    },

    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },

    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },

    possedeSelectionPertinente () {
      return getFromSnake(this.sitimmoUser, 'selection_pertinente')
    },

    nbStocks () {
      return this.sitimmoUser.stocks.length
    },

    stocks () {
      return this.sitimmoUser.stocks
    },

    page: {
      get () {
        return this.filter.page
      },
      async set (value) {
        window.scrollTo(0, 0)
        this.setPage(value)
        await this.fetchList()
        this.toggleSelection()
      }
    },

    limit: {
      get () {
        return this.filter.limit
      },
      async set (value) {
        this.setLimit(value)
        await this.fetchList()
        this.toggleSelection()
      }
    },

    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        await this.fetchList()
        this.toggleSelection()
      }
    },

    isModeSelectionAutomatiqueManuelleParAnnonceur () {
      return (this.portal !== null && this.portal.infos !== null) && (
        this.portal.infos.modeSelectionAutomatique === 'manuelle par l\'annonceur' ||
        this.portal.infos.modeSelectionAutomatique === 'manual por el anunciante' ||
        this.portal.infos.modeSelectionAutomatique === 'manual by the advertiser'
      )
    },

    // Propriétés temporaires (à terme, ces données devraient venir du store)
    quotaPerUser () {
      // Calcul basé sur les données disponibles ou valeur par défaut
      return this.getUserQuotaPerPortal !== null
    },

    stockPostForUser () {
      // Flag temporaire, devrait être calculé selon la logique métier
      return false // À adapter selon les besoins
    },

    nbAnnoncesSelectionneesForUser () {
      //  NOUVELLE APPROCHE : Données venant du nouvel endpoint backend /dashboard-stats
      return this.getSelectedAdsCurrentUser || 0
    },

    totalAnnonceForUser () {
      // Total des annonces pour l'utilisateur
      // À calculer selon la logique métier ou récupérer du store
      return 0 // À adapter
    },

    //  NOUVELLE APPROCHE : Utilisation directe des getters Vuex alimentés par le nouvel endpoint backend

    // ===== COMPUTED POUR ApiSearchForm =====
    templateCode () {
      // Le template sera sélectionné automatiquement selon le businessDomain et le user_type
      return null // Le backend choisira entre broadcast_selection_agence, broadcast_selection_promoteur, broadcast_selection_bailleur, broadcast_selection_vo
    },
    businessDomain () {
      return this.univers ? this.univers.toLowerCase() : 'immo'
    },
    route () {
      return 'portals/broadcast/{portal}'
    }
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  async mounted () {
    await this.$store.dispatch('broadcast/initializeBroadcast', { portalId: this.portalId })
  },

  watch: {
    // Surveille les changements du quota personnel depuis le store
    getQuotaPersonnel: {
      handler (newValue) {
        this.quotaPersonnel = newValue
      },
      immediate: true
    }
  },

  methods: {
    ...mapMutations('broadcast', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'resetFilter',
      'setResults'
    ]),

    eventAnalytics (category) {
      this.$ga.event('selection_annonces', 'clic', category, this.sitimmoUser.id)
    },

    resetSearch () {
      this.resetFilter()
      this.fetchList()
    },

    /**
     * Handler pour la recherche depuis ApiSearchForm
     */
    async handleSearchFromApi (filters) {
      this.addFilter(filters)
      await this.fetchList()
    },

    /**
     * Handler pour la réinitialisation depuis ApiSearchForm
     */
    async handleResetFromApi () {
      console.log('🔄 [BROADCAST] Réinitialisation depuis ApiSearchForm')

      // Réinitialiser les filtres
      this.resetFilter()

      // Relancer la recherche
      await this.fetchList()
    },

    async fetchList () {
      // Méthode simplifiée utilisant l'action du store
      const result = await this.$store.dispatch('broadcast/buildFiltersAndLoadPosts', {
        portalId: this.portalId,
        portalCodeName: this.getPortalCodeName,
        isPromoteur: this.isPromoteur
      })

      if (!result.success) {
        console.error('Erreur lors du chargement des annonces:', result.error)
      }
      return result.success
    },

    async trieTableau (column) {
      const diffuseurId = this.portal && this.portal.infos && this.portal.infos._embedded && this.portal.infos._embedded.diffuseur ? this.portal.infos._embedded.diffuseur.id : null

      // Utiliser diffuseurId comme dans l'ancienne version si disponible
      const idToUse = diffuseurId || this.portalId

      // Appeler handleSortChange pour mettre à jour le state
      await this.$store.dispatch('broadcast/handleSortChange', {
        column,
        portalId: idToUse
      })

      // Forcer le rechargement des données
      await this.fetchList()
      this.toggleSelection()
    },

    canSelectRow (row, index) {
      if (this.portal && this.portal.infos && this.portal.infos.modeSelectionAutomatique && this.portal.infos.modeSelectionAutomatique.includes('automatique')) {
        return false
      }
      if (this.possedeSelectionPertinente === true) {
        if (row.selectionPertinente !== '0') {
          return true
        } else {
          return false
        }
      }
      return true
    },

    doSelect (type) {
      switch (type) {
        case '*':
          const tmpSelection = (this.results && this.results.list ? this.results.list : []).map(({ id }) => id)
          this.selected = _uniq(this.selected.concat(tmpSelection))
          this.toggleSelection()
          break
        case null:
        default:
          this.selected = []
          this.$refs.table.clearSelection()
      }
    },

    upperCase (string) {
      if (string) {
        return string.charAt(0).toUpperCase() + string.substr(1)
      } else {
        return null
      }
    },

    formatMessageTooltip (message) {
      let messageFinal = message
      messageFinal = messageFinal.replace('<br />', '<br/>')
      return messageFinal
    },

    async validerSelection () {
      // Fermeture des modales
      this.confirmDiffusionList = false
      this.programValidLotModal = false

      // Délégation complète au store (validation + activation + rechargement + messages)
      const result = await this.$store.dispatch('broadcast/handleActivationWithUI', {
        portalId: this.portalId,
        selected: this.selected,
        activate: true,
        checkLots: this.checkLots,
        isPromoteur: this.isPromoteur,
        isBailleurSocial: this.isBailleurSocial,
        annonceParente: this.filter.annonceParente,
        messageHandler: this.$message,
        messages: {
          success: this.$t('portals.broadcast.messageSuccessDiffusion'),
          successDeactivation: this.$t('portals.broadcast.messageSuccessDeactivation')
        }
      })

      // Reset de la sélection si succès
      if (result.success && result.cleared) {
        this.selected = []
      }
    },

    async desactiverSelection () {
      // Fermeture de la modale
      this.confirmDesactivationList = false

      // Délégation complète au store (validation + désactivation + rechargement + messages)
      const result = await this.$store.dispatch('broadcast/handleActivationWithUI', {
        portalId: this.portalId,
        selected: this.selected,
        activate: false,
        checkLots: this.checkLots,
        isPromoteur: this.isPromoteur,
        isBailleurSocial: this.isBailleurSocial,
        annonceParente: this.filter.annonceParente,
        messageHandler: this.$message,
        messages: {
          success: this.$t('portals.broadcast.messageSuccessDiffusion'),
          successDeactivation: this.$t('portals.broadcast.messageSuccessDeactivation')
        }
      })

      // Reset de la sélection si succès
      if (result.success && result.cleared) {
        this.selected = []
      }
    },

    toggleSelection () {
      if (this.$refs.table && this.results && this.results.list) {
        this.results.list.forEach(row => {
          if (this.selected.includes(row.id)) {
            this.$refs.table.toggleRowSelection(row, true)
          }
        })
      }
    },

    selectAllChanged (selection) {
      // Sélection/désélection simplifiée
      if (!selection.length) {
        // Désélection : retirer tous les IDs de la page courante
        if (this.results && this.results.list) {
          const currentPageIds = this.results.list.map(item => item.id)
          this.selected = this.selected.filter(id => !currentPageIds.includes(id))
        }
      } else {
        // Sélection de tous les éléments de la page
        this.doSelect('*')
      }
    },

    selectedChanged (selection, row) {
      // Logique simplifiée : vérifier si la ligne est sélectionnée
      const isSelected = selection.some(item => item.id === row.id)
      const index = this.selected.indexOf(row.id)

      if (isSelected && index === -1) {
        // Ajouter à la sélection
        this.selected.push(row.id)
      } else if (!isSelected && index > -1) {
        // Retirer de la sélection
        this.selected.splice(index, 1)
      }
    },

    setProgramme (id) {
      // Délégation complète au store pour navigation vers programme
      this.$store.dispatch('broadcast/handleProgramNavigation', {
        id,
        portalId: this.portalId,
        portalCodeName: this.getPortalCodeName,
        isPromoteur: this.isPromoteur
      })
    },

    retourProgramme () {
      // Délégation complète au store pour retour aux programmes
      this.$store.dispatch('broadcast/handleProgramNavigation', {
        id: null,
        portalId: this.portalId,
        portalCodeName: this.getPortalCodeName,
        isPromoteur: this.isPromoteur
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.Broadcast {
  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    border: none !important;
  }
}
</style>
